import React, { memo } from "react";
import PT from "prop-types";
import { CircleButton } from "_c/button";
import { LinkGenerator } from "@/utils/LinkGenerator";
import VkIcon from "_c/icon/Vk";
import InstaIcon from "_c/icon/Instagram";
import FacebookIcon from "_c/icon/Facebook";
import MessageIcon from "_c/icon/Message";
import PhoneIcon from "_c/icon/Phone";
import EnvelopeIcon from "_c/icon/Envelope";
import MessagePopover from "_c/Popover/Message";
import { stripPhone } from "@/utils";

const ProfileContacts = (props) => {
  const phone = stripPhone(props.phone);
  const waId = stripPhone(props.waId);
  const viberId = stripPhone(props.viberId);
  return (
    <div
      css={`
        --contact-size: 24px;
        display: flex;
        justify-content: center;
        @media (min-width: ${({ theme }) => theme.mobileBp}) {
          justify-content: flex-start;
        }
        flex-wrap: wrap;
        img {
          display: block;
        }
        > *,
        button,
        img {
          width: var(--contact-size);
          height: var(--contact-size);
          min-width: var(--contact-size);
          min-height: var(--contact-size);
        }
        a:first-child {
          margin-left: 0;
        }
        a:last-child {
          margin-right: 0;
        }
        > * {
          margin: 5px;
          box-shadow: none;
        }
      `}
    >
      {phone && (
        <CircleButton large as="a" href={LinkGenerator.phone(props.phone)}>
          <PhoneIcon width="10" color="white" />
        </CircleButton>
      )}
      {phone && (
        <CircleButton large as="a" href={LinkGenerator.sms(phone)}>
          <MessageIcon width="16" color="white" />
        </CircleButton>
      )}
      {waId && (
        <a
          large
          as="a"
          target="_blank"
          rel="noopener nofollow"
          href={`https://wa.me/${waId}`}
        >
          <img src="/icons/whatsapp.svg" />
        </a>
      )}
      {viberId && (
        <a
          large
          as="a"
          target="_blank"
          rel="noopener nofollow"
          href={`viber://chat?number=${viberId}`}
        >
          <img src="/icons/viber.svg" />
        </a>
      )}
      {props.tgId && (
        <a
          large
          as="a"
          target="_blank"
          rel="noopener nofollow"
          href={LinkGenerator.tg(props.tgId)}
        >
          <img src="/icons/telegram.svg" />
        </a>
      )}
      {props.vkId && (
        <CircleButton
          target="_blank"
          rel="noopener nofollow"
          large
          as="a"
          href={LinkGenerator.vk(props.vkId)}
        >
          <VkIcon color="white" width="14" />
        </CircleButton>
      )}
      {props.instaId && (
        <CircleButton
          large
          as="a"
          target="_blank"
          rel="noopener nofollow"
          href={LinkGenerator.insta(props.instaId)}
        >
          <InstaIcon color="white" width="14" />
        </CircleButton>
      )}
      {props.fbId && (
        <CircleButton
          target="_blank"
          rel="noopener nofollow"
          large
          as="a"
          href={LinkGenerator.fb(props.fbId)}
        >
          <FacebookIcon color="white" width="8" />
        </CircleButton>
      )}
      {props.isAuth && !props.isOwner && (
        <MessagePopover t={props.t} onSubmit={props.sendMessage}>
          <CircleButton
            large
            title={props.t("common:write")}
            id="profile__message"
          >
            <EnvelopeIcon width="12" color="white" />
          </CircleButton>
        </MessagePopover>
      )}
    </div>
  );
};

export default memo(ProfileContacts);
